import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Mail, ArrowUpRight } from 'lucide-react'
import Links from './Link'

function Footer({ setIsModalOpen }) {
  const navigate = useNavigate()

  const openContact = () => {
    if (setIsModalOpen) setIsModalOpen(true)
    else window.dispatchEvent(new CustomEvent('pdv:open-contact'))
  }

  const goCreations = () => {
    navigate('/')
    setTimeout(() => document.getElementById('Creation')?.scrollIntoView({ behavior: 'smooth' }), 400)
  }

  return (
    <footer className="relative overflow-hidden border-t border-white/10 mt-10">
      <div
        aria-hidden="true"
        className="absolute inset-x-0 top-0 h-px"
        style={{ background: 'linear-gradient(90deg, transparent, rgba(176,107,255,0.6), transparent)' }}
      />
      <span className="blob" style={{ background: 'rgba(138,43,226,0.22)', width: 460, height: 460, top: '-40%', left: '15%' }} aria-hidden="true" />

      <div className="container-pdv relative z-10 py-16">
        <div className="grid gap-12 lg:grid-cols-[1.6fr_1fr_1.2fr]">
          {/* Marque */}
          <div>
            <Links to="/" aria-label="Place des Victoires — accueil" className="inline-flex">
              <video width="440" loop autoPlay muted playsInline className="h-24 w-[4.5rem] md:h-32 md:w-24 object-cover object-center">
                <source src="/logo6.webm" type="video/webm" />
              </video>
            </Links>
            <p className="mt-5 max-w-sm text-[#a99bd0] leading-relaxed">
              Studio de création multimédia inclusif en Entreprise Adaptée.
            </p>
          </div>

          {/* Navigation */}
          <nav aria-label="Pied de page">
            <h3 className="font-display font-bold text-white mb-4">Navigation</h3>
            <ul className="space-y-2.5 text-[#bcaee6]">
              <li><Links to="/" className="hover:text-white underline-animation">Accueil</Links></li>
              <li><Links to="/quisommenous" className="hover:text-white underline-animation">Qui sommes-nous&nbsp;?</Links></li>
              <li><Links to="/prestations" className="hover:text-white underline-animation">Nos prestations</Links></li>
              <li><button onClick={goCreations} className="hover:text-white underline-animation">Nos créations</button></li>
              <li><Links to="/plan-du-site" className="hover:text-white underline-animation">Plan du site</Links></li>
            </ul>
          </nav>

          {/* Contact */}
          <div>
            <h3 className="font-display font-bold text-white mb-4">Contact</h3>
            <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between md:gap-4 lg:flex-col lg:items-start lg:gap-5">
              <a
                href="mailto:contact@placedesvictoires.tech"
                className="inline-flex items-center gap-2.5 text-[#bcaee6] hover:text-white transition-colors underline-animation"
              >
                <span className="grid place-items-center h-9 w-9 rounded-xl glass">
                  <Mail size={16} />
                </span>
                contact@placedesvictoires.tech
              </a>
              <button onClick={openContact} className="btn btn-primary group shrink-0">
                Démarrer un projet
                <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </button>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-[#8d80b3]">
          <p>© {new Date().getFullYear()} Place des Victoires. Tous droits réservés.</p>
          <p>Conçu avec soin · Accessibilité au cœur de chaque pixel.</p>
        </div>
        <p className="mt-4 text-xs text-[#9b8fc4]">
          Police Luciole © Laurent Bourcellier &amp; Jonathan Perez — Licence CC BY 4.0.
        </p>
      </div>
    </footer>
  )
}

export default Footer
